export default "__VITE_ASSET__DfC9GCXb__"